import React from 'react';
import { ExternalLink } from 'lucide-react';
import { certifications } from '../data/mock';
import { Card } from './ui/card';

const Certifications = () => {
  return (
    <section id="certifications" className="section-padding section-dark">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Certifications</h2>
          <div className="section-underline"></div>
        </div>
        <div className="certifications-grid">
          {certifications.map((cert) => (
            <Card key={cert.id} className="certification-card">
              <div className="certification-year">{cert.year}</div>
              <h3 className="certification-name">{cert.name}</h3>
              <p className="certification-issuer">{cert.issuer}</p>
              {cert.link && (
                <a
                  href={cert.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="certification-link"
                >
                  <ExternalLink size={16} />
                  <span>View Certificate</span>
                </a>
              )}
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;